import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/(member)/(protected)/my/settings/")({
  beforeLoad: async () => {
    throw redirect({
      to: "/my/settings/account/profile",
    });
  },
});
